import { Helper } from '@rawlings/core';
//#region Imports
import { DialogService } from '@app/core/services/dialog-service.service';
import { FailedRequestComponent } from '../shared/components/failed-request/failed-request.component';
import { FailedRequestDialogComponent } from '../shared/components/failed-request-dialog/failed-request-dialog.component';
import { Injectable } from '@angular/core';
import { SharedMemberResponseService } from './shared-member-response.service';
import { MemberResponsePortalResponseDto } from '@app/core/models/memberResponsePortalResponseDto';
//#endregion Imports
@Injectable({
  providedIn: 'root'
})
export class NotificationRequestService {
    //#region Constructor
    constructor(
        private dialogService: DialogService,
        private sharedMemberResponseService: SharedMemberResponseService
    ){}
    //#endregion Constructor

    //#region Public Methods
    public ShowFailedRequestAndLogout(data: MemberResponsePortalResponseDto | null) : void {
        this.sharedMemberResponseService.DeleteSession();
        Helper.IsEmpty(data) ?  this.dialogService.OpenDialog(FailedRequestComponent) :  this.dialogService.OpenDialogFailedRequest(FailedRequestDialogComponent, data);
    }
    //#endregion Public Methods

    //#region Private Methods
    //#endregion Private Methods
}
